import "./DevListPopup.scss";
import block from "bem-cn";
import Button from "../Button/Button";
import { useAppSelector } from "../../app/hooks";
import { selectPickedDevelopers } from "../App/AppSlice";
import { routes } from "../../routes";

const b = block("DevListPopup");

type Props = {
  isShowen?: boolean;
  list?: string[];
};

const DevListPopup = ({ isShowen = false, list = [] }: Props) => {
  const l = useAppSelector(selectPickedDevelopers);
  const count = l.length;

  return (
    <div className={b({ shown: count > 0 }).mix("clear")}>
      <div className={b("Button-wrapper")}>
        <Button link={routes.booking} hasBorder text="Бронировать" />
      </div>
      <p className={b("list")}>{l.join(", ")}</p>
    </div>
  );
};

export default DevListPopup;
